<!--
 * @Author: guoyu
 * @Date: 2020-08-28 10:22:08
 * @LastEditors: your name
 * @LastEditTime: 2021-04-12 17:01:27
 * @Description: 选择计价单位
-->
<template>
  <div class="unit-box">
    <div class="unit-select">
      <span class="unit-title">計費模式</span>
      <div class="select-text" @click="openPopup">
        <span
          >{{ currentItem.name || '標準模式' }}
          <i class="mode-price"
            >{{ currentItem.price }}幣/{{
              currentItem.salesUnit | salesUnitTranslate
            }}
          </i>
        </span>
        <GeneralSelect
          class="el-select-mode"
          v-model="currentUnit"
          :options="unitLsit"
          :disabled="!!$route.query.quickMatchUuid"
          valKey="id"
          @change="getCurrentChange"
        >
          <template v-slot="{ item }">
            <p class="mode-item">
              <span>{{ item.name }}</span>
              <span class="mode-price"
                >{{ item.price }}幣/{{
                  item.salesUnit | salesUnitTranslate
                }}</span
              >
            </p>
          </template>
        </GeneralSelect>
        <i class="poupup-icon fps-icon fps-icon-arrow-right"></i>
      </div>
    </div>
    <el-drawer class="unit-popup drawer-clear-style" :visible.sync="popupShow" direction="btt" append-to-body :show-close="false">
      <div class="unit-container-title">
        選擇計費模式
        <i
          class="close-icon fps-icon fps-icon-close"
          @click="popupShow = false"
        ></i>
      </div>
      <GeneralCheckbox
        class="unit-list"
        v-model="currentUnit"
        :options="unitLsit"
        :col="1"
        valKey="id"
      >
        <template v-slot="{ item, checked }">
          <div class="unit-item" :class="{ checked }">
            <span class="unit-name">{{ item.name }}</span>
            <span class="unit-num"
              >{{ item.price }}幣/{{
                item.salesUnit | salesUnitTranslate
              }}</span
            >
          </div>
        </template>
      </GeneralCheckbox>
      <div class="confirm-button" @click="getCurrentChange">確認</div>
    </el-drawer>
  </div>
</template>

<script>
import GeneralCheckbox from '@/components/common/checkbox/general-checkbox';
import GeneralSelect from '@/components/common/select';
export default {
  components: {
    GeneralCheckbox,
    GeneralSelect
  },
  model: {
    prop: 'val',
    event: 'change'
  },
  props: {
    skillInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    val: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isFromNew: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentUnit: this.$route.query.price | 0 || 0,
      popupShow: false
    };
  },
  computed: {
    unitLsit() {
      let modeList = this.skillInfo.skillPriceList || [];
      return [
        {
          id: 0,
          name: '標準模式',
          price: this.skillInfo.salesPrice,
          salesUnit: this.skillInfo.salesUnit
        },
        ...modeList
      ];
    },
    currentItem() {
      return this.unitLsit.find(item => {
        return item.id === this.currentUnit;
      }) || {};
    }
  },
  methods: {
    getCurrentChange() {
      this.$emit('change', this.currentItem);
      this.popupShow = false;
    },
    openPopup() {
      // 极速约单模式不可选
      if (this.$route.query.quickMatchUuid) return
      this.popupShow = true;
      this.currentUnit = this.currentItem.id || 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.unit-box {
  position: relative;
  height: 70px;
  padding: 0 18px;
  background: #ffffff;
  border-bottom: 2px solid #f4f4f4;
  color: #333333;
}
.unit-title {
  font-weight: 500;
}
.unit-select {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  font-size: 16px;
  line-height: 20px;
}
.el-select-mode {
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  width: 300px;
  height: 100%;
  opacity: 0;
}

.mode-price {
  font-size: 14px;
  color: #8c94aa;
}
.mode-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: $color-gray-1;
  font-weight: 400;
}
.poupup-icon {
  margin-left: 7px;
  font-size: 11px;
}
.unit-popup {
  width: 100%;
  overflow: hidden;
  border-radius: 20px 20px 0px 0px;
}
.unit-container-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 28px 0;
  border-bottom: 1px solid #e0e0e0;
  margin: 0 20px;
  font-weight: 500;
  font-size: 16px;
  line-height: 1;
}
.close-icon {
  position: absolute;
  top: 0x;
  right: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  background: rgba(249, 249, 249, 0.78);
  color: #8e8e93;
  font-size: 20px;
}
.unit-list {
  padding: 20px 20px 12px;
  font-size: 14px;
  /deep/ .check-item {
    width: 100%;
  }
}
.unit-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 44px;
  padding: 0 24px;
  margin-bottom: 12px;
  border-radius: 8px;
  background: #f1f3f6;
}
.checked {
  background: #f0f7ff;
  border: 1.5px solid #5baaff;
}
.confirm-button {
  margin: 0 20px 47px;
  height: 48px;
  background: $color-yellow;
  text-align: center;
  line-height: 48px;
  border-radius: 20px;
  font-weight: 500;
  font-size: 18px;
}
.unit-name {
  font-weight: 500;
}
.unit-num {
  color: #636d86;
}
@media screen and (min-width: 600px) {
  .unit-box {
    padding: 0;
  }
  .select-text {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 34px;
    width: 300px;
    padding: 0 16px;
    background: #f9f9f9;
    border: 0.5px solid #e8eaee;
    border-radius: 4px;
  }
  .el-select-mode {
    display: block;
  }
}
</style>
